import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  AbnComponentValue,
  AcnComponentValue,
  AggregatorSearchComponentValue,
  AzureStorageDocument,
  UploadedDocumentRef,
  booleanToYesNo,
  BusinessSearchValue,
  constants,
  DocumentTag,
  EntityTypeCompanyOption, EntityTypeOtherOption, EntityTypePartnershipOption, EntityTypes, EntityTypeSoleTraderOption, EntityTypeTrustOption, EntityTypeValue,
  filesToBase64Files,
  GetSalesforceContactSameAccountFunc,
  GetUserSameCompanyFunc,
  InsurancePremiumApplication,
  isAddressEquals,
  isApplicationApplicantIndividual, isApplicationApplicantsSoleTrader,
  isExternalUser,
  NotNullable, OriginatorBusiness,
  patchAcn,
  PolicyValue,
  SalesforceContactSameAccountSelectionValue,
  SelectContactValue,
  toDraftSimplifiedApplication,
  UploadAzureFiles, UploadFileValue,
  UserSameCompanySelectionValue,
  UserSelectionValue,
  GetIndustryDivisionsFn,
  GetIndustryGroupsByDivisionCodeFn,
  GetIndustryClassesByGroupCodeFn,
  BORROWING_ENTITY_LOCKED_HINT,
  ApplicationCommercialEntityWrite,
} from '@portal-workspace/grow-shared-library';
import {
  AggregatorSearchComponent,
  AggregatorSearchFn,
  AnnualRevenueValue,
  applicantsThatAreIndividual,
  applicationToAbn,
  applicationToAcn,
  applicationToAdditionalBrokerCorrespondent,
  applicationToApplicants,
  applicationToApplicationNotes,
  applicationToAuthorisedSignatories,
  applicationToBrokerContact,
  applicationToBrokerSearchValue,
  applicationToBusinessSearchValue,
  applicationToHasAdditionalBrokerCorrespondent,
  applicationToIndustrySector,
  applicationToLegalName,
  applicationToOrganisationType,
  applicationToPolicies,
  applicationToPrimaryAddress,
  applicationToRegisteredBusinessAddress,
  applicationToPrimaryContact,
  applicationToPrimaryIndustry,
  applicationToSubdivisionIndustrySector,
  applicationToRevenue,
  BusinessNumberSearchComponent,
  BusinessNumberSearchFn,
  BusinessSearchFn,
  PolicyComponentCalcFn as CalcFn,
  duplicateFileNameValidator,
  formControlErrorKeys,
  formControlErrorMessage,
  fromApplicantToInteflowCommercialEntities,
  fromApplicantToInteflowIndividualsData, fromContactToInteflowContacts,
  getUser,
  maxFileUploadValidator,
  SalesforceContactSameAccountSelectionComponent,
  setStepper2StepConfig,
  setupUntilDestroy,
  toApiAddress,
  toInteflowEntityTypes,
  toInteflowLegalName,
  UserSameCompanySelectionComponent
} from '@portal-workspace/grow-ui-library';
import { Observable, Subscription, of, catchError, from, lastValueFrom } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { Location, NgTemplateOutlet } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Address2ComponentValue, AppCalculator, ApplicationApplicant, ApplicationTypes, AuthorisedSignatoryValue, Base64File, BrokerOfUser, defaultDocuments, GeoLocation, InsurancePremiumSummary, LoanPurposeValue, PlacesDetailsFn, PlacesSearchResultFn, PrimaryIndustrySelectionValue, RatecardDetails, SecondaryIndustrySelectionValue, SubdivisionIndustrySelectionValue, TermRate, UpdateApplicationData,
  WizardSubmitData, UploadAzureFilesValue, RequiredTrustDeed, User, KybRefreshFn, KybResultFn, KybSetManualModeFn, KybResult, kybHasOwnKeyPeople, KybKeyPeopleValue, KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE, IndividualDetailsListValue, KybInitiateCorporatePartyFn } from '@portal-workspace/grow-shared-library';
import { AbnComponent, AcnComponent, AnnualRevenueComponent, ApplicationDialogService, ApplicationHeaderSegmentComponent, ApplicationStepper2Component, AuthorisedSignatoryComponent, BusinessSearchComponent, CustomAddressComponent, DirectorComponent, EntityTypeComponent, InsurancePremiumSummaryComponent, LoanPurposeSelectionComponent, MarkDirective, MemberComponent, MessageBoxComponent, MobileComponent, PartnerComponent, PolicyComponent, PortalHotToastService, PrimaryIndustrySelectionComponent, SecondaryIndustrySelectionComponent, SelectContactComponent, SoleTraderComponent, TrustDeedUploadComponent, TrusteeComponent, UploadedFilesListComponent, UploadedFilesListComponentEvent, UploadFileComponent, UploadFilesMultiTagsComponent, UserSelectionComponent, YesNoComponent } from '@portal-workspace/grow-ui-library';
import _ from 'lodash';
import { environment } from '../../../environments/environment';
import {
  ApplicationService,
} from '../../service/application.service';
import { AuthService } from '../../service/auth.service';
import { DigitalIdService } from '../../service/digital-id.service';
import { LocalApplicationsDbService } from "../../service/local-applications-db.service";
import {
  navigationUrlForApplicationsWithQueryParams,
  navigationUrlForInsurancePremiumWithQueryParams,
  navigationUrlForNewApplication
} from '../../service/navigation-urls';
import { SubdivisionIndustrySelectionComponent } from '@portal-workspace/grow-ui-library';
import { KybKeyPeopleComponent, KybStatusComponent, tagIndividualIdDocumentFiles } from '@portal-workspace/grow-ui-library';
import {
  IndividualDetailsListComponent,
  consentAcknowledgementIndividuals,
  mergeSavedIndividualsIntoInteflowIndividuals,
  savedIndividualsToPrimaryContact,
  savedIndividualsToContacts,
} from '@portal-workspace/grow-ui-library';
import { IndustryService } from '../../service/industry.service';

// NOTE: Page to land when you are in DRAFT (new unsubmitted) insurance premium application
@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    templateUrl: './insurance-premium.page.html',
    styleUrls: ['./insurance-premium.page.scss'],
    standalone: true,
    imports: [
      ApplicationStepper2Component,
      BusinessNumberSearchComponent,
      CdkStepperModule,
      NgTemplateOutlet,
      FormsModule,
      ReactiveFormsModule,
      BusinessSearchComponent,
      MarkDirective,
      MatCheckboxModule,
      MatTooltipModule,
      UserSelectionComponent,
      PolicyComponent,
      EntityTypeComponent,
      AbnComponent,
      AcnComponent,
      AnnualRevenueComponent,
      YesNoComponent,
      PrimaryIndustrySelectionComponent,
      SecondaryIndustrySelectionComponent,
      CustomAddressComponent,
      MobileComponent,
      TrusteeComponent,
      SoleTraderComponent,
      PartnerComponent,
      DirectorComponent,
      MemberComponent,
      KybKeyPeopleComponent,
      KybStatusComponent,
      IndividualDetailsListComponent,
      ApplicationHeaderSegmentComponent,
      AuthorisedSignatoryComponent,
      MessageBoxComponent,
      TrustDeedUploadComponent,
      UploadedFilesListComponent,
      UploadFileComponent,
      UploadFilesMultiTagsComponent,
      MatFormFieldModule,
      MatInputModule,
      InsurancePremiumSummaryComponent,
      UserSameCompanySelectionComponent,
      AggregatorSearchComponent,
      SalesforceContactSameAccountSelectionComponent,
      LoanPurposeSelectionComponent,
      SubdivisionIndustrySelectionComponent
    ]
})
export class InsurancePremiumPage implements OnInit {

  @HostListener( 'window: popstate', ['$event'])
    async onPopState(event: Event): Promise<void> {
      event.preventDefault();
      await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
    }
  @ViewChild('uploadFilesMultiTagsComponent') uploadFilesMultiTagsComponent!: UploadFilesMultiTagsComponent;
  @ViewChild(LoanPurposeSelectionComponent) loanPurposeComponent!: LoanPurposeSelectionComponent;

  getIndustryDivisionsFn!: GetIndustryDivisionsFn;
  getIndustryGroupsByDivisionCodeFn!: GetIndustryGroupsByDivisionCodeFn;
  getIndustryClassesByGroupCodeFn!: GetIndustryClassesByGroupCodeFn;
  businessSearchPlaceholder:string="Enter name or ABN…"
  applicationType: ApplicationTypes = "InsurancePremium";
  existingApplication: InsurancePremiumApplication | null = null; // will exists if there is a draft
  rateCard: RatecardDetails | null = null;
  placesSearchResultFn!: PlacesSearchResultFn;
  placesDetailsFn!: PlacesDetailsFn;
  subscriptions: Subscription[] = [];

  queryParams: Params = {};

  defaultDocuments = defaultDocuments;

  errorKeys = formControlErrorKeys;
  errorMessages = formControlErrorMessage;

  // global:
  ip: string = '';
  geoLocation: GeoLocation = {};
  user: User = getUser()!;
  isExternalUser : boolean = isExternalUser(this.user);
  otherUsersObservable?: Observable<NotNullable<UserSelectionValue>[]>;
  brokerOfUser: BrokerOfUser | null = null;
  brokerApplicationId: string | null = null;
  applicationId: number | null = null;
  acceptedQuotation = false;

  // ADO-1295: the borrowing entity locks once the broker moves off the application step, so the
  // company check and key-people selections stay anchored to the chosen entity. An application id
  // exists only after that step has been saved, which also covers a reopened draft.
  get borrowingEntityLocked(): boolean {
    return !!this.applicationId;
  }

  get step1BusinessLockedHint(): string | null {
    return this.borrowingEntityLocked ? BORROWING_ENTITY_LOCKED_HINT : null;
  }

  // global: step 5 onwards
  organisationName: string = ''
  terms: TermRate | null = null;          // available on / after step2
  calculator: AppCalculator | null = null;   // available on / after step2

  // after popup confirmation
  businessUseOnly = false;
  selfServiceability = false;


  // STEP 1:
  step1SearchFn!: BusinessSearchFn;
  step1GetUserSameCompanyFn!: GetUserSameCompanyFunc;
  step1GetSalesforceContactSameAccountFn!: GetSalesforceContactSameAccountFunc;
  step1BrokerSearchFn!: AggregatorSearchFn;
  step1OrgSalesforceId: string | null = null;
  step1NoOtherUsersInCompany = true;
  formControlStep1Broker!: FormControl<AggregatorSearchComponentValue>;

  formGroupStep1!: FormGroup<{
    broker: FormControl<AggregatorSearchComponentValue>,
    business: FormControl<BusinessSearchValue>,
    showCorrespondent: FormControl<boolean | null>,
    correspondent: FormControl<UserSelectionValue>,
    brokerContact:FormControl<SalesforceContactSameAccountSelectionValue>
  }>;
  formControlStep1Business!: FormControl<BusinessSearchValue>;
  formControlStep1ShowCorrespondent!: FormControl;
  formControlStep1Correspondent!: FormControl<UserSameCompanySelectionValue>;
  formControlStep1BrokerContact!: FormControl<SalesforceContactSameAccountSelectionValue>;

  // STEP 2:
  step2CalcFn!: CalcFn;
  step2MonthlyInstallment: number | null = null;
  step2BrokerageFee: number | null = null;
  step2DocFee: number | null = null;  // application fee
  formControlStep2Policies!: FormControl<PolicyValue>;
  formControlStep2LoanPurpose!: FormControl<LoanPurposeValue>;
  formGroupStep2!: FormGroup<{
    policies: FormControl<PolicyValue>,
    loanPurpose: FormControl<LoanPurposeValue>,
  }>;

  // STEP 3:
  step3OnwardsOrganisationType: EntityTypes | null = null;
  formControlStep3OrganisationType!: FormControl<EntityTypeValue>;
  formControlStep3Abn!: FormControl<AbnComponentValue>;
  formControlStep3Acn!: FormControl<AcnComponentValue>;
  formControlStep3Revenue!: FormControl<AnnualRevenueValue>;
  formControlStep3PrimaryIndustry!: FormControl<PrimaryIndustrySelectionValue>;
  formControlStep3IndustrySector!: FormControl<SecondaryIndustrySelectionValue>;
  formControlStep3PrimaryBusinessAddress!: FormControl<Address2ComponentValue>;
  formControlStep3RegisteredBusinessAddress!: FormControl<Address2ComponentValue>;
  formControlStep3SubdivisionIndustrySector!: FormControl<SubdivisionIndustrySelectionValue>;
  // The company check the step waits on. Held so step 4 can render its key people without a second
  // read, and so a re-entered step shows the form immediately instead of waiting again.
  step3KybResult: KybResult | null = null;
  step3ManualKyb = false;
  // The stepper builds every step's content up front, so the company check must not begin waiting
  // until this step is actually reached.
  step3Active = false;
  step3KybResultFn!: KybResultFn;
  step3KybRefreshFn!: KybRefreshFn;
  kybSetManualModeFn!: KybSetManualModeFn;

  /**
   * Whether the form is still behind the applicant's company check.
   *
   * A trust or partnership is let straight through: its key people are the trustees/partners typed
   * in on step 4, so this step reads nothing from that run. Those brokers enter both addresses by
   * hand, because the registry prefill arrives with the same result.
   */
  get step3AwaitingKyb(): boolean {
    return !this.step3ManualKyb
      && !this.step3KybResult
      && kybHasOwnKeyPeople(this.step3OnwardsOrganisationType);
  }

  formGroupStep3!: FormGroup<{
    organisationType: FormControl<EntityTypeValue>,
    abn: FormControl<AbnComponentValue>,
    acn: FormControl<AcnComponentValue>,
    revenue: FormControl<AnnualRevenueValue>,
    primaryIndustry: FormControl<PrimaryIndustrySelectionValue>,
    industrySector: FormControl<SecondaryIndustrySelectionValue>,
    subdivisionIndustrySector: FormControl<SubdivisionIndustrySelectionValue>,
    primaryBusinessAddress: FormControl<Address2ComponentValue>,
    registeredBusinessAddress: FormControl<Address2ComponentValue>,
  }>;

  step3PrimaryIndustryDivisionCode: string | null = null;
  step3IndustrySectorGroupCode: string | null = null;
  // STEP 4:
  step4BusinessSearchFn!: BusinessSearchFn;
  step4BusinessNumberSearchFn!: BusinessNumberSearchFn;
  step4KybResultFn!: KybResultFn;
  step4KybInitiateCorporatePartyFn!: KybInitiateCorporatePartyFn;
  step4KybWarnings: string[] = [];
  // As step3Active: the step is built up front, so its waiting panel must not start before it is
  // reached.
  step4Active = false;
  formControlStep4Applicants!: FormControl<ApplicationApplicant>;
  formControlStep4KybKeyPeople!: FormControl<KybKeyPeopleValue | null>;
  formGroupStep4!: FormGroup<{
    applicants: FormControl<ApplicationApplicant>,
    kybKeyPeople: FormControl<KybKeyPeopleValue | null>,
  }>;

  // STEP 6:
  formControlStep6AuthorisedSignatories!: FormControl<AuthorisedSignatoryValue>;
  formGroupStep6!: FormGroup<{
    authorisedSignatories: FormControl<AuthorisedSignatoryValue>,
  }>;

  // STEP 7: individual details review (also where the primary contact is chosen)
  formControlStep7IndividualDetails!: FormControl<IndividualDetailsListValue>;
  formGroupStep7!: FormGroup<{
    individualDetails: FormControl<IndividualDetailsListValue>,
  }>;
  @ViewChild('individualDetailsListComponent') individualDetailsListComponent?: IndividualDetailsListComponent;
  @ViewChild(KybKeyPeopleComponent) kybKeyPeopleComponent?: KybKeyPeopleComponent;


  step9UploadedDocs: AzureStorageDocument[] = [];
  applicationDocuments: AzureStorageDocument[] | null = null;
  step4DeletedIdDocuments: UploadedDocumentRef[] = [];
  step9DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  filesUploadedToAzure: Base64File[] = [];

  // step 8: trust deeds. Derived here rather than inside the step so the stepper can leave the step
  // out entirely when the application needs no deed.
  requiredTrustDeeds: RequiredTrustDeed[] = [];
  step8DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  formControlStep8TrustDeeds!: FormControl<UploadAzureFilesValue>;
  formGroupStep8!: FormGroup<{
    trustDeeds: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 9:
  formControlStep9OtherSupportingDocuments!: FormControl<UploadAzureFilesValue>;
  formGroupStep9!: FormGroup<{
    otherSupportingDocuments: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 10:
  formControlStep10ApplicationNotes!: FormControl<string | null>;
  formGroupStep10!: FormGroup<{
    applicationNotes: FormControl<string | null>,
  }>;

  // STEP 11:
  step11Summary!: InsurancePremiumSummary;
  formGroupStep11!: FormGroup<{}>;

  showAddressFormFlag = false
  documentTypes: DocumentTag[] = [];


  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private toastService: PortalHotToastService,
              private applicationService: ApplicationService,
              private localApplicationDbService: LocalApplicationsDbService,
              private router: Router,
              private location: Location,
              private applicationDialogService: ApplicationDialogService,
              private digitalIdService: DigitalIdService,
              private authService: AuthService,
              private industryService: IndustryService) {
    this.placesSearchResultFn = this.authService.getGooglePlacesSearchResultFn;
    this.placesDetailsFn = this.authService.getGooglePlacesDetailsFn; 
    this.getIndustryDivisionsFn = this.industryService.getIndustryDivisionsFn;
    this.getIndustryGroupsByDivisionCodeFn = this.industryService.getIndustryGroupsByDivisionCodeFn;
    this.getIndustryClassesByGroupCodeFn = this.industryService.getIndustryClassesByGroupCodeFn;
  }

  async ngOnInit() {
    setupUntilDestroy(this)
    this.queryParams = this.route.snapshot.queryParams ?? {};
    this.existingApplication = (this.route.snapshot.data as any).application;
    this.rateCard = (this.route.snapshot.data as any).ratecard;
    console.log('Resolved [InsurancePremium] application', this.existingApplication);
    if (this.existingApplication) {
      if (this.existingApplication.ApplicationType != 'InsurancePremium') {
        this.toastService.error(`This application ${this.existingApplication.ApplicationId} is not an Insurance Premium application`, `Invalid application type`);
      }
    }

    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.initStep4();
    this.initStep6();
    this.initStep7();
    this.initStep8();
    this.initStep9();
    this.initStep10();
    this.initStep11();
    this.populate();

    // get ip
    const sub1 = this.applicationService.getIpAddress().pipe(
      map(r => {
        if (r.status) {
          this.ip = r.payload;
          console.log('**** ip', this.ip);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub1);

    // get geolocation
    try {
      const geoLocation = await this.applicationService.getGeoLocation();
      if (geoLocation) {
        this.geoLocation = geoLocation;
      }
      console.log('**** geolocation', geoLocation);
    } catch(err) {
      alert(err);
    }

    // get broker of user
    const sub2 = this.applicationService.getBrokerOfUser(this.user.UserId).pipe(
      tap(r => {
        if (r.status) {
          this.brokerOfUser = r.payload;
        }
      })
    ).subscribe();
    this.subscriptions.push(sub2);
  }

  populate() {
    if (this.existingApplication) {
      // 1
      this.formControlStep1Business.setValue(applicationToBusinessSearchValue(this.existingApplication));
      this.formControlStep1ShowCorrespondent.setValue(applicationToHasAdditionalBrokerCorrespondent(this.existingApplication));
      this.formControlStep1Correspondent.setValue(applicationToAdditionalBrokerCorrespondent(this.existingApplication));
      this.brokerApplicationId = this.existingApplication.BrokerAppId;
      this.applicationId = this.existingApplication.ApplicationId;
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.organisationName = applicationToLegalName(this.existingApplication) ?? '';
      const brokerSearchValue = applicationToBrokerSearchValue(this.existingApplication);
      this.formControlStep1Broker.setValue(brokerSearchValue);
      this.step1OrgSalesforceId = brokerSearchValue?.salesforceId ?? null;
      this.formControlStep1BrokerContact.setValue(applicationToBrokerContact(this.existingApplication))

      // 2
      this.formControlStep2Policies.setValue(applicationToPolicies(this.existingApplication));
      this.formControlStep2LoanPurpose.setValue(this.existingApplication.AppInfo?.LoanPurpose ?? null);

      // 3
      this.formControlStep3OrganisationType.setValue(applicationToOrganisationType(this.existingApplication));
      this.formControlStep3Abn.setValue(applicationToAbn(this.existingApplication));
      this.formControlStep3Acn.setValue(applicationToAcn(this.existingApplication));
      this.formControlStep3Revenue.setValue(applicationToRevenue(this.existingApplication));
      const primaryIndustry = applicationToPrimaryIndustry(this.existingApplication);
      const industrySector = applicationToIndustrySector(this.existingApplication);
      this.formControlStep3PrimaryIndustry.setValue(primaryIndustry);
      // Set division code for secondary industry component
      this.step3PrimaryIndustryDivisionCode = primaryIndustry?.code ?? null;
      this.step3IndustrySectorGroupCode = industrySector?.code ?? null;
      this.formControlStep3IndustrySector.setValue(industrySector);

      this.formControlStep3PrimaryBusinessAddress.setValue(applicationToPrimaryAddress(this.existingApplication));
      this.formControlStep3RegisteredBusinessAddress.setValue(applicationToRegisteredBusinessAddress(this.existingApplication));
      this.formControlStep3SubdivisionIndustrySector.setValue(applicationToSubdivisionIndustrySector(this.existingApplication));

      // 4
      {
        const v = applicationToApplicants(this.existingApplication);
        this.formControlStep4Applicants.setValue(v);
        if (this.formControlStep4Applicants.value !== null) {
          let propertyOwner: any
          let residentialAddress: any
          if (isApplicationApplicantsSoleTrader(this.formControlStep4Applicants.value)) {
            propertyOwner = this.formControlStep4Applicants.value.propertyOwner;
            residentialAddress = this.formControlStep4Applicants.value.residentialAddress;
          }
          else {
            const applicant = this.formControlStep4Applicants.value;
            for (let i = 0; i <= applicant.length - 1; i++) {
              const currentApplicant = applicant[i];
              if (isApplicationApplicantIndividual(currentApplicant)) {
                propertyOwner = currentApplicant.propertyOwner;
                residentialAddress = currentApplicant.residentialAddress;
              }
            }
          }
          if (propertyOwner) {
            if (propertyOwner.propertyOwner) {
              if (isAddressEquals(residentialAddress, propertyOwner.address)) {
                this.showAddressFormFlag = false;
              }
            }
          }
        }

      }

      // 6
      {
        const v = applicationToAuthorisedSignatories(this.existingApplication);
        this.formControlStep6AuthorisedSignatories.setValue(v);
      }

      // 7 is the individual details step - it loads its own rows from ApplicationIndividual

      // 8-10
      this.formControlStep10ApplicationNotes.setValue(applicationToApplicationNotes(this.existingApplication));
      this.listUploadedDocuments();
      this.refreshRequiredTrustDeeds();
      this.documentTypes = this.existingApplication.DocumentTypes ?? [];

    } else {  // not prepopulating ie. creating new application

      // auto populate originator business if we have one
      const orignatorBusinessId = this.user?.OriginatorBusinessId;
      if (orignatorBusinessId) {
        this.subscriptions.push(this.applicationService.getOriginatorBusinessById(orignatorBusinessId).pipe(
          tap(r => {
            if (r.payload) {
              const originatorBusiness: OriginatorBusiness = r.payload;
              const v: AggregatorSearchComponentValue = {
                abn: originatorBusiness.ABN,
                entityName: originatorBusiness.EntityName,
                salesforceId: originatorBusiness.SalesforceId,
              }
              this.formControlStep1Broker.setValue(v);
            }
          })
        ).subscribe());
      }
      this.documentTypes = this.applicationDefaultDocuments(false);
    }
  }

  initStep1() {
    this.step1BrokerSearchFn = (term)=> {
      return this.applicationService.searchBroker2(term).pipe(map(r => r.payload));
    }
    this.formControlStep1Business = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Broker = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1ShowCorrespondent = this.formBuilder.control(false)
    this.formControlStep1Correspondent = this.formBuilder.control(null);
    this.formControlStep1BrokerContact = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep1 = this.formBuilder.group({
      broker: this.formControlStep1Broker,
      business: this.formControlStep1Business,
      showCorrespondent: this.formControlStep1ShowCorrespondent,
      brokerContact:this.formControlStep1BrokerContact,
      correspondent: this.formControlStep1Correspondent,
    });
    this.step1SearchFn = this.applicationService.businessSearchFn;
    this.step1GetUserSameCompanyFn = (orgSalesforceId: string) => {
      return this.authService.getOtherUsersInCompanyBySalesforceIdFn(orgSalesforceId).pipe(
        map(r => {
          // exclude this user
          const filteredCorrespndentUserList =  r.filter(u => u.UserId != this.user.UserId);
          this.step1NoOtherUsersInCompany = filteredCorrespndentUserList.length == 0;
          return filteredCorrespndentUserList;
        })
      );
    }
    this.step1GetSalesforceContactSameAccountFn = this.authService.getSalesforceContactSameAccountFn;
    this.subscriptions.push(this.formControlStep1Broker.valueChanges.pipe(
      tap(broker => {
        if (broker) {
          this.step1OrgSalesforceId = broker.salesforceId;
          this.step1GetUserSameCompanyFn(this.step1OrgSalesforceId).pipe().subscribe();
        }
      })
    ).subscribe());
    this.subscriptions.push(this.formControlStep1ShowCorrespondent.valueChanges.pipe(
      tap((r: Boolean)=> {
        if(!r){
          this.formControlStep1Correspondent.setValue(null)
        }
      })
    ).subscribe())
    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r && r.type === 'search-result') { // NOTE: we can deduce only when business is an ASIC/ABN search
          if (r.result?.entityType) {
            const description = r.result.entityType.entityDescription;
            const code = r.result.entityType.entityTypeCode;

            if ('IND' == code) {
              this.formControlStep3OrganisationType.setValue(EntityTypeSoleTraderOption);
            } else if (description && description.toLowerCase().indexOf('trust') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypeTrustOption);
            } else if (description && description.toLowerCase().indexOf('company') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypeCompanyOption);
            } else if (description && description.toLowerCase().indexOf('partnership') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypePartnershipOption);
            } else {
              this.formControlStep3OrganisationType.setValue(EntityTypeOtherOption);
            }
          }
        }
      })
    ).subscribe());

    const sub = this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r) {
          if (r) {
            if (r.abn && this.formControlStep3Abn) {
              this.formControlStep3Abn.setValue(r.abn);
            }
            if (r.acn && this.formControlStep3Acn) {
              const acn = patchAcn(r.acn);
              this.formControlStep3Acn.setValue(acn ?? null);
            }

            this.organisationName = toInteflowLegalName(r) ?? '';
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);

    setStepper2StepConfig(this.formGroupStep1, {
      nextStepClickedFn: async (stepper) => {
        await this.saveApplication(stepper, 1);
      },
      previousStepClickedFn: async (stepper) => {
        if(this.applicationId){
          await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
        }else {
          await this.router.navigate(navigationUrlForNewApplication());
        }
      }
    });
  }

  initStep2() {
    this.step2CalcFn = (total,  paidBy) => {
      // todo: calculate monthly installment, application fee, estimated drawdown date etc. form ratecard

      const loanTerms = Number(paidBy);
      const totalAmount = total;

      const calculator = new AppCalculator();
      const terms = calculator.getTotalInterestRateForInsurancePremiumFinance(this.rateCard!, {totalPremiumAmount: totalAmount});
      this.terms = terms;
      this.calculator = calculator;

      const interestRate = terms.totalInterest / 100;
      const interestAmount = interestRate * totalAmount;

      const docFee = terms.docFee;
      const brokerageAmount = _.round((interestAmount * 20 / 100 ), 2);
      const repayment = _.round(totalAmount * (1  + interestRate) / loanTerms, 2);

      return of({
        monthlyInstallment: repayment,
        applicationFee: docFee,
        brokerage: brokerageAmount,
      }).pipe(
        tap(r => {
          // keep a copy of estimate drawdown date & monthly installment
          this.step2MonthlyInstallment = r.monthlyInstallment;
          this.step2DocFee = r.applicationFee;
          this.step2BrokerageFee = r.brokerage;
        })
      );
    };
    this.formControlStep2Policies = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2LoanPurpose = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep2 = this.formBuilder.group({
      policies: this.formControlStep2Policies,
      loanPurpose: this.formControlStep2LoanPurpose,
    });
    setStepper2StepConfig(this.formGroupStep2, {
      nextStepClickedFn: async stepper => {
        // Add loan purpose validation check              
        // Mark all fields as touched to trigger validation
        this.loanPurposeComponent?.mark();
        
        // Check if the loan purpose component is invalid
        if (this.loanPurposeComponent?.formGroup?.invalid) {
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: 'Please complete all required loan purpose fields'
          });
          return;
        }
         // Keep existing validation logic
        await this.saveApplication(stepper, 2);
      }
    })
  }

  initStep3() {
    this.formControlStep3OrganisationType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Abn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Acn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Revenue = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryIndustry = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3IndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3RegisteredBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3SubdivisionIndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep3 = this.formBuilder.group({
      organisationType: this.formControlStep3OrganisationType,
      abn: this.formControlStep3Abn,
      acn: this.formControlStep3Acn,
      revenue: this.formControlStep3Revenue,
      primaryIndustry: this.formControlStep3PrimaryIndustry,
      industrySector: this.formControlStep3IndustrySector,
      primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress,
      registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress,
      subdivisionIndustrySector: this.formControlStep3SubdivisionIndustrySector,
    });
    // Identify the applicant, so they come from step 1's verified business search and are not
    // re-typed here: changing them would invalidate the company check this step waits on.
    this.formControlStep3Abn.disable();
    this.formControlStep3Acn.disable();
    this.step3KybResultFn = this.applicationService.kybResultFn;
    this.step3KybRefreshFn = this.applicationService.kybRefreshFn;
    this.kybSetManualModeFn = this.applicationService.kybSetManualModeFn;
    const sub = this.formControlStep3OrganisationType.valueChanges.pipe(
      tap((r: EntityTypeValue) => {
        if (r) {
          if(this.step3OnwardsOrganisationType && this.step3OnwardsOrganisationType !== r.type) {
            // the org type changes and is different from prev value
            this.formControlStep4Applicants.setValue(null)
          }
          this.step3OnwardsOrganisationType = r.type;
          if (r && r.type === 'company') {
            /* Not required to set it again as validation is already set */
          } else {
            this.formControlStep3Acn.setValidators(null);
            this.formControlStep3Acn.updateValueAndValidity();
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);
        // Listen for primary industry changes and fetch secondary industries
        const primaryIndustrySub = this.formControlStep3PrimaryIndustry.valueChanges.pipe(
          tap((primaryIndustry: PrimaryIndustrySelectionValue) => {
            if (primaryIndustry && primaryIndustry.code) {
              // Clear current secondary industry selection
              this.formControlStep3IndustrySector.setValue(null);
              this.formControlStep3SubdivisionIndustrySector.setValue(null);
              
              // Update division code for secondary industry component
              this.step3PrimaryIndustryDivisionCode = primaryIndustry.code;
              this.step3IndustrySectorGroupCode = null;
            } else {
              // Clear division code when primary industry is cleared
              this.step3PrimaryIndustryDivisionCode = null;
              this.formControlStep3IndustrySector.setValue(null);
              this.formControlStep3SubdivisionIndustrySector.setValue(null);
            }
          })
        ).subscribe();
        this.subscriptions.push(this.formControlStep3IndustrySector.valueChanges.pipe(
          tap((secondaryIndustry: SecondaryIndustrySelectionValue) => {
            if (secondaryIndustry && secondaryIndustry.code) {
              this.step3IndustrySectorGroupCode = secondaryIndustry.code;
              this.formControlStep3SubdivisionIndustrySector.setValue(null);
            }else{
              this.step3IndustrySectorGroupCode = null;
              this.formControlStep3SubdivisionIndustrySector.setValue(null);
            }
          })
        ).subscribe());
     
        this.subscriptions.push(primaryIndustrySub);
        
   setStepper2StepConfig(this.formGroupStep3, {
    stepSelectionEventFn: () => {
      this.step3Active = true;
    },
    // The form is not on screen until the company check lands, so there is nothing to advance to.
    nextStepButtonDisabledFn: () => this.step3AwaitingKyb,
    nextStepClickedFn: async stepper => {
          await this.saveApplication(stepper, 3);
    }
  });

  }

  /**
   * The applicant's company check finished. Prefill both addresses from the registry into their
   * matching fields, leaving anything the broker already saved on a previous visit alone, and keep
   * the result for step 4.
   */
  onStep3KybResolved(result: KybResult) {
    this.step3KybResult = result;
    const primaryEntity = result.entities.find(entity => entity.isPrimary);
    this.step3ManualKyb = primaryEntity?.mode === 'MANUAL';
    const addresses = primaryEntity?.addresses ?? null;
    // Tested on the address line rather than the object: a saved entity with an empty address still
    // hydrates into a fully-shaped value, which reads as answered while showing the broker nothing.
    if (addresses?.registeredOffice && !this.formControlStep3RegisteredBusinessAddress.value?.address) {
      this.formControlStep3RegisteredBusinessAddress.setValue(addresses.registeredOffice);
    }
    if (addresses?.principalPlaceOfBusiness && !this.formControlStep3PrimaryBusinessAddress.value?.address) {
      this.formControlStep3PrimaryBusinessAddress.setValue(addresses.principalPlaceOfBusiness);
    }
  }

  onStep3ManualKyb(): void {
    if (this.applicationId == null) return;
    this.kybSetManualModeFn(this.applicationId).subscribe({
      next: result => this.onStep3KybResolved(result),
      error: () => undefined,
    });
  }

  initStep4() {
    // Step 4 is now the Key People (KYB) summary screen; the legacy applicants control is retained
    // (null, unvalidated) so the existing null-safe save path keeps compiling. Detailed individual
    // capture is a separate follow-up ticket.
    this.step4BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step4BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.step4KybResultFn = this.applicationService.kybResultFn;
    this.step4KybInitiateCorporatePartyFn = this.applicationService.kybInitiateCorporatePartyFn;
    this.formControlStep4Applicants = this.formBuilder.control(null);
    this.formControlStep4KybKeyPeople = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep4 = this.formBuilder.group({
      applicants: this.formControlStep4Applicants,
      kybKeyPeople: this.formControlStep4KybKeyPeople,
    });
    setStepper2StepConfig(this.formGroupStep4, {
      stepSelectionEventFn: () => {
        this.step4Active = true;
      },
      nextStepValidationMessage: KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
      nextStepClickedFn: async stepper => {
        if (!await this.confirmStep4KybWarnings()) {
          return;
        }
        await this.saveApplication(stepper, 4);
      }
    });
  }

  // KYB warnings are advisory, so they are raised here (on Next) rather than inline on the step;
  // continuing is allowed once the user confirms.
  private async confirmStep4KybWarnings(): Promise<boolean> {
    if (!this.step4KybWarnings.length) {
      return true;
    }
    const result = await this.applicationDialogService
      .openKybWarningsConfirmationDialog(this.step4KybWarnings)
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep6() {
    this.formControlStep6AuthorisedSignatories = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep6 = this.formBuilder.group({
      authorisedSignatories: this.formControlStep6AuthorisedSignatories,
    });

    setStepper2StepConfig(this.formGroupStep6, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 6);
      }
    });
  }

  // individual details review, including the primary contact selection
  initStep7() {
    this.formControlStep7IndividualDetails = this.formBuilder.control(null);
    this.formGroupStep7 = this.formBuilder.group({
      individualDetails: this.formControlStep7IndividualDetails,
    });
    setStepper2StepConfig(this.formGroupStep7, {
      stepSelectionEventFn: e => {
        // re-read from the DB every time the step is entered - the KYB key people and authorised
        // signatory steps may have added or changed individuals in between. Wait on the previous
        // step's draft save first, otherwise this read races the write that creates those rows and
        // a signatory added on the step before wouldn't show up until the step is re-entered.
        this.individualDetailsListComponent?.reload(this.pendingDraftSave);
      },
      previousStepClickedFn: async stepper => {
        // flush pending edits so navigating back doesn't lose them
        await this.individualDetailsListComponent?.flushChanges();
        stepper.previous();
      },
      nextStepClickedFn: async stepper => {
        // persists through /save-application-parties; deliberately NOT updateDraftInBg - the
        // legacy Individuals payload rebuilt from earlier step values would overwrite the edits
        // that were just saved on this step. mapToInteflowData re-applies them on later saves.
        const flushed = await this.individualDetailsListComponent?.flushChanges() ?? true;
        if (flushed) {
          stepper.next();
        }
      },
    });
  }

  // trust deeds
  initStep8() {
    this.formControlStep8TrustDeeds = this.formBuilder.control(null);
    this.formGroupStep8 = this.formBuilder.group({
      trustDeeds: this.formControlStep8TrustDeeds,
    });
    setStepper2StepConfig(this.formGroupStep8, {
      nextStepButtonText: 'Next',
      // Uploading is optional, so the step never blocks Next; a deed not supplied here stays a
      // required document on the Documents tab after submission.
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 8);
      },
    });
  }

  /**
   * Re-derive which entities need a deed. Called as the parties settle, since a trust added at the
   * key-people step changes the answer.
   */
  refreshRequiredTrustDeeds() {
    if (!this.applicationId) {
      return;
    }
    this.subscriptions.push(
      this.applicationService.requiredTrustDeedsFn(this.applicationId).subscribe({
        next: deeds => this.requiredTrustDeeds = deeds,
        // Leaves the step hidden; the deeds are still collected as conditions after submission.
        error: () => this.requiredTrustDeeds = [],
      }),
    );
  }

  onStep8DeleteUploadedDoc(deletedFile: AzureStorageDocument) {
    this.step8DeletedUploadedDocs = [...this.step8DeletedUploadedDocs, deletedFile];
    this.step9UploadedDocs = this.step9UploadedDocs.filter(doc => doc.name !== deletedFile.name);
  }

  // other supporting doc
  initStep9() {
    this.formControlStep9OtherSupportingDocuments = this.formBuilder.control(null,[duplicateFileNameValidator(),maxFileUploadValidator(2)]);
    this.formGroupStep9 = this.formBuilder.group({
      otherSupportingDocuments: this.formControlStep9OtherSupportingDocuments,
    });


    setStepper2StepConfig(this.formGroupStep9, {
      nextStepButtonText:'Next',
      stepSelectionEventFn: e => {
        this.documentTypes = this.applicationDefaultDocuments(true);
      },
      nextStepClickedFn: async stepper => {
        const isMissingTagsCheck = this.formGroupStep9.value.otherSupportingDocuments?.filter(file => file.tags && file.tags.length === 0) ;
        if(isMissingTagsCheck?.length){
          const fileNames = isMissingTagsCheck.map(file => file.name).join(', ');
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: `The following files are missing tags: ${fileNames}`
          });

        }else {
          await this.saveApplication(stepper, 9);
        }
      }
    });
  }

  // application note
  initStep10() {
    this.formControlStep10ApplicationNotes = this.formBuilder.control(null);
    this.formGroupStep10 = this.formBuilder.group({
      applicationNotes: this.formControlStep10ApplicationNotes,
    });


    setStepper2StepConfig(this.formGroupStep10, {
      nextStepButtonText:'Next to Review',
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 10);
      }
    });
  }

  initStep11(){
    this.formGroupStep11 = this.formBuilder.group({ });

    setStepper2StepConfig(this.formGroupStep11, {
      nextStepButtonText:'Submit',
      stepSelectionEventFn: e => {
         
        
          this.step11Summary = {
            monthlyRepayment: String(this.step2MonthlyInstallment) ?? '',
            applicationId: String(this.applicationId),


            organisation: this.formControlStep1Business.value,
            organisationType: this.formControlStep3OrganisationType.value,
            addtionalBrokerCorrespondent: this.formControlStep1Correspondent.value,
            abn: this.formControlStep3Abn.value!,
            acn: this.formControlStep3Acn.value!,

            annualRevenue: this.formControlStep3Revenue.value!,
            primaryIndustry: this.formControlStep3PrimaryIndustry.value,
            industrySector: this.formControlStep3IndustrySector.value,
            subdivisionIndustrySector:  this.formControlStep3SubdivisionIndustrySector.value,
            primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress.value,
            registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress.value,

            policies: this.formControlStep2Policies.value,
            loanPurpose: this.formControlStep2LoanPurpose.value,

            applicants: this.formControlStep4Applicants.value ?? [],

            authorisedSignatories: this.formControlStep6AuthorisedSignatories.value,

            primaryContact: savedIndividualsToPrimaryContact(this.formControlStep7IndividualDetails.value?.individuals)!,
            contacts: savedIndividualsToContacts(this.formControlStep7IndividualDetails.value?.individuals),

            applicationNotes: this.formControlStep10ApplicationNotes.value!,
            brokerContact:this.formControlStep1BrokerContact.value!
          };
      },
      nextStepClickedFn: async stepper => {
        this.finalSubmission(stepper, this.step11Summary!);
      }
    });
  }


  finalSubmission(stepper: CdkStepper, summary: InsurancePremiumSummary) {
    // todo: perform submission
    consentAcknowledgementIndividuals(
      this.digitalIdService.getApplicationIndividualsFn,
      this.applicationId,
      this.formControlStep7IndividualDetails.value?.individuals,
    ).pipe(
      this.toastService.topMenuLoadingObservable(),
      switchMap(individuals => this.applicationDialogService
        .openInsurancePremiumApplicationConfirmationDialog(individuals).afterClosed()),
      tap(async r => {
        if (r && r.readyForSubmission) {
          this.businessUseOnly = false;
          this.selfServiceability = true;
          await this.sendFinalSubmission(stepper);
        }
      })
    ).subscribe();
  }

  async sendFinalSubmission(stepper: CdkStepper) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData(true);

      // update driver licence doc metadata - as the individualId will be changed
      if (this.applicationId) {
        this.subscriptions.push(
          this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
            (r: AzureStorageDocument[]) => {
              const driverLicenceDocs = r.filter(obj => Object.values(obj?.tags ?? {}).includes('driverslicence'));
              for (const doc of driverLicenceDocs) {
                const individual = (data.parties?.individuals ?? []).find(obj => (doc.metadata?.driverslicencename ?? '') == `${obj.givenName ?? ''} ${obj.surname ?? ''}`);
                if (individual && individual.guid) {
                  this.applicationService.updateDocumentMetadataFn(doc.name, "", {
                    ...doc.metadata,
                    individualid: individual.guid ?? ''
                  }).subscribe()
                }
              }
            }
          )
        )
      }

      const sub = this.applicationService.submitInsurancePremium(this.applicationId, data).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          if (r && r.status) {
            this.applicationDialogService.openApplicationSubmittedDialog().afterClosed().pipe(
              tap(async r => {
                stepper.reset();
                stepper.next();
                await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {reload: true}));
              })
            ).subscribe();
          } else {
            this.applicationDialogService.openAlertDialog({
              message: `Error`,
              subMessage: r.message
            });
          }
        })
      ).subscribe();
      this.subscriptions.push(sub);
    }
  }


  private async saveApplication(stepper: CdkStepper, step: number) {
    if (!this.applicationId) { // application was not saved before (new draft)
      const inteflowData = await this.mapToInteflowData();
      this.applicationService.saveApplication(inteflowData).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          const applicationId = r.payload.ApplicationId;
          const brokerApplicationId = r.payload.BrokerApplicationId;
          this.brokerApplicationId = brokerApplicationId;
          this.applicationId = applicationId;
          this.syncUrlWithApplicationId();
          const business: BusinessSearchValue = this.formControlStep1Business.value
          if (business) {
            this.organisationName = business.organisationName;
          }
          this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, inteflowData));
          stepper.next();
        }),
        catchError(err => {
          this.applicationDialogService.openAlertDialog({
            message: 'Error',
            subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
          });
          return of(null);
        })
      ).subscribe();
    } else {  // existing draft
      const inteflowData = await this.mapToInteflowData();
      console.log('**** inteflowdata', inteflowData);
      try {
        await this.updateDraftInBg(step);
        stepper.next();
      } catch (err: any) {
        this.applicationDialogService.openAlertDialog({
          message: 'Error',
          subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
        });
      }
    }
  }

  // Put the new draft's id in the address bar so a refresh reopens it instead of starting a blank
  // application. replaceState rather than router.navigate: 'insurance-premium' and
  // 'insurance-premium/:applicationId' are separate route configs, so navigating would rebuild this
  // component and discard everything the user has entered.
  private syncUrlWithApplicationId() {
    if (!this.applicationId) {
      return;
    }
    const urlTree = navigationUrlForInsurancePremiumWithQueryParams(this.router, this.applicationId, this.queryParams);
    this.location.replaceState(this.router.serializeUrl(urlTree));
  }

  // Steps that re-read parties can wait on the most recent draft save.
  private pendingDraftSave: Promise<void> = Promise.resolve();

  private async updateDraftInBg(step: number, fn?: ()=>void) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData();
      // KYB "Key People" (step 4) rides on the same update-application2 request as the rest of the
      // parties so both saves share one transaction and cannot race/clobber role flags.
      if (step === 4 && this.formControlStep4KybKeyPeople.value) {
        data.kybKeyPeople = this.formControlStep4KybKeyPeople.value;
      }
      this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, data));
      const save = this.applicationService.updateApplication(this.applicationId, data).pipe(
        tap(() => {
          if (fn) {
            fn();
          }
          // The entity and key-people steps are what decide whether a deed is needed, so the trust
          // deed step's visibility is settled once their save has landed.
          if (step === 4 || step === 7) {
            this.refreshRequiredTrustDeeds();
          }
        })
      );
      // The Azure upload and SQL draft update are independent. Run them together, but keep one
      // loading lifecycle and require both acknowledgements before the step can advance.
      const saveOperation = from(Promise.allSettled([
        this.uploadFileToAzure(step, data),
        lastValueFrom(save),
      ])).pipe(
        fn
          ? this.toastService.loadingWithMessage(`Saving, please be patient`)
          : this.toastService.spinnerObservable(),
        map(results => {
          const failed = results.find(result => result.status === 'rejected');
          if (failed?.status === 'rejected') {
            throw failed.reason;
          }
        }),
      );
      const savePromise = lastValueFrom(saveOperation);
      this.pendingDraftSave = savePromise.then(() => undefined, () => undefined);
      await savePromise;
    }
  }

  async uploadFileToAzure(step: number, data: WizardSubmitData) {
    let base64Files: Base64File[] = [];
    let allToBeDeleted: string[] = [];
    let allFiles: File[] = [];
    if (step === 4) {
      allFiles = tagIndividualIdDocumentFiles(
        this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? [],
        data.parties?.individuals ?? [],
        this.step9OtherDocMetadata,
      );
      allToBeDeleted = this.step4DeletedIdDocuments.map(document => document.name);
    } else if (step === 8) { // trust deeds, already tagged with the condition they were dropped into
      const trustDeeds = this.formControlStep8TrustDeeds.value;
      allToBeDeleted = [...this.step8DeletedUploadedDocs].map(file => file.name);
      if (trustDeeds && trustDeeds.length) {
        allFiles = [...trustDeeds];
      }
    } else if (step === 9) { // other supporting doc
      const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
      allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
      if (otherSupportingDocs && otherSupportingDocs.length) {
        allFiles = [...otherSupportingDocs];
      }
    } else {
      return;
    }
    base64Files = [...await filesToBase64Files(allFiles)];
    // double check if any changes with existing files
    // remove file that has been uploaded
    base64Files = base64Files.map(file => {
      file.metadata = file.tags?.includes('driverslicence') ? file.metadata : this.step9OtherDocMetadata
      return file;
    }).filter(f => {
      const fileIdentifiers = this.filesUploadedToAzure.map(m =>
        `${m.name}${m.tags?.join(' ')}${m.metadata?.individualid ?? m.metadata?.driverslicencename ?? ''}`);
      return !fileIdentifiers.includes(
        `${f.name}${f.tags?.join(' ')}${f.metadata?.individualid ?? f.metadata?.driverslicencename ?? ''}`,
      );
    })
    if (!base64Files.length && !allToBeDeleted.length) {
      return;
    }

    if (this.applicationId) {
      await lastValueFrom(
        this.applicationService.uploadApplicationDocumentToAzureStorage(
          this.applicationId,
          [...base64Files],
          allToBeDeleted,
        ),
      );
      this.filesUploadedToAzure = [...this.filesUploadedToAzure, ...base64Files];
      if(step === 4){
        this.listUploadedDocuments()
        this.step4DeletedIdDocuments = [];
      }else if(step === 8){
        this.listUploadedDocuments()
        this.step8DeletedUploadedDocs = []
        this.formControlStep8TrustDeeds.setValue(null)
      }else if(step === 9){
        this.uploadFilesMultiTagsComponent.files = []
        this.uploadFilesMultiTagsComponent.filesWithTags = []
        this.uploadFilesMultiTagsComponent.formControl.setValue(null)
        this.listUploadedDocuments()
        this.formControlStep9OtherSupportingDocuments.setValue(null)
      }
    }
  }

  async mapToInteflowData(finalSubmission = false) {

    const user = getUser();
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const correspondentDetails: UserSelectionValue = this.formControlStep1Correspondent.value;
    const broker: AggregatorSearchComponentValue = this.formControlStep1Broker.value;
    const o: EntityTypeValue = this.formControlStep3OrganisationType.value;
    const applicationNotes = this.formControlStep10ApplicationNotes.value;
    // primary contact is selected on the individual details step and flagged on the saved rows
    const savedIndividualDetails = this.formControlStep7IndividualDetails.value;
    const contact: SelectContactValue = savedIndividualsToPrimaryContact(savedIndividualDetails?.individuals);
    const policies: PolicyValue = this.formControlStep2Policies.value;
    const abn = this.formControlStep3Abn.value;
    const acn = this.formControlStep3Acn.value;
    const applicants: ApplicationApplicant = this.formControlStep4Applicants.value;

     // workout broker salesforce id
     let brokerSalesforceId = broker!.salesforceId;
     let brokerAbn = broker!.abn;
     let brokerEntityName = broker!.entityName;
     if (user!.BrokerSalesforceId === environment.GrowFinanceGroupSalesforceId) {
       if (broker && broker.salesforceId) {
         brokerSalesforceId = broker.salesforceId;
         brokerAbn = broker.abn;
         brokerEntityName = broker.entityName;
       } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId) {
         brokerSalesforceId = this.brokerOfUser.SalesforceId;
         brokerAbn = this.brokerOfUser.ABN;
         brokerEntityName = this.brokerOfUser.EntityName;
       }
     }
     else {
       if (broker) { // broker dropdown selection is being populated
         // use the declared brokerSalesforceId, brokerAbn and brokerEntityName
       } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId !== undefined) {
         // broker drop down selection is not being populated, we populate it with the current user's company details
         brokerSalesforceId = this.brokerOfUser.SalesforceId;
         brokerAbn = this.brokerOfUser.ABN;
         brokerEntityName = this.brokerOfUser.EntityName;
       }
     }

    // workout disclosure
    let disclosed = true;
    let introducerGroup = 'ECLIPXCOMMERCIAL';
    if (this.brokerOfUser) {
      if (this.brokerOfUser.Relationship !== 'disclosed') {
        disclosed = false;
        introducerGroup = 'UNDISCLOSED_ECLIPXCOMMERCIAL';
      }
    }

    // work out legalName & entityTYpe
    let legalName = toInteflowLegalName(b) ?? undefined;
    let entityType = o ? toInteflowEntityTypes(o.type) : undefined;

    // work out industries
    const primaryIndustry: PrimaryIndustrySelectionValue = this.formControlStep3PrimaryIndustry.value;
    const secondaryIndustry: SecondaryIndustrySelectionValue = this.formControlStep3IndustrySector.value;
    const subdivisionIndustrySector: SubdivisionIndustrySelectionValue = this.formControlStep3SubdivisionIndustrySector.value;
    const revenue = this.formControlStep3Revenue.value;
    const address: Address2ComponentValue = this.formControlStep3PrimaryBusinessAddress.value;
    const registeredAddress: Address2ComponentValue = this.formControlStep3RegisteredBusinessAddress.value;

    // pricing details
    const loanTerm = (policies?.paidByMonthlyInstallment != null ? Number(policies.paidByMonthlyInstallment) : undefined);


    // bureau report / company details
    const companyDetails = (b && b.type === 'search-result' && b?.result) ?
      b.result :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails : undefined;



    // entities
    const primaryCommercialEntity: ApplicationCommercialEntityWrite = {
      legalName: legalName ?? undefined,
      entityType: entityType,
      abn: abn ?? undefined,
      // Replaces the ACN delete below: a non-company posts no ACN at all.
      acn: (entityType !== 'PTY' || _.isEmpty(acn)) ? undefined : (acn ?? undefined),
      tradingName: '',
      // Replaces Type: 'Primary'. This is the borrower, so it holds no relationship to another entity.
      isPrimary: true,
      isGuarantor: false,
      relationships: [],
      industry: {
        primaryIndustry: primaryIndustry?.code ?? undefined,
        industrySector: secondaryIndustry?.code ?? undefined,
        // Filed under subdividionClass here, and under industryClass by asset-finance - preserved
        // as-is either way, see doc §17.6.
        subdividionClass: subdivisionIndustrySector?.code ?? undefined,
      },
      revenue: revenue ? Number(revenue) : undefined,
      businessCategory: 'SME ($1m+ Revenue | $0.5m to $5m Capital)',
      principalPlaceOfBusiness: toApiAddress(address),
      registeredBusinessAddress: toApiAddress(registeredAddress),
      abnAgeMonths: (b && b.type === 'search-result' && b?.result) ?
      b.result.ABNAgeMonths :
      this.existingApplication?.CompanyDetails ? (this.existingApplication.CompanyDetails as any).ABNAgeMonths : undefined
    }

    // commercial entities
    const otherCommercialEntities = fromApplicantToInteflowCommercialEntities(applicants);
    const otherCommercialEntity = [
      ...otherCommercialEntities,
    ];


    // individuals
    const applicantIndividuals = fromApplicantToInteflowIndividualsData(applicants);
    const otherIndividuals = [
      ...applicantIndividuals,
    ];


    // file tags
    const otherSupportingDocs: UploadAzureFilesValue = this.formControlStep9OtherSupportingDocuments.value;
    const allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
    let allFiles: File[] = tagIndividualIdDocumentFiles(
      this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? [],
      otherIndividuals,
      this.step9OtherDocMetadata,
    );
    if (otherSupportingDocs && otherSupportingDocs.length) {
      allFiles = [...allFiles, ...otherSupportingDocs];
    }
    allFiles = [...allFiles].filter(file => !allToBeDeleted.includes(file?.name));

    // get doc types
    let uploadedTags = allFiles.reduce((tags: string[], file) => [...tags, ...((file as any).tags ?? [])], []);
    uploadedTags = [...uploadedTags, ...this.step9UploadedDocs.reduce((tags: string[], file: AzureStorageDocument) => [...tags, ...Object.values(file?.tags ?? {})], [])];
    uploadedTags = [...new Set(uploadedTags)];
    console.log('=====uploadedTags: ', uploadedTags);
    for (const tag of uploadedTags) {
      if (!this.documentTypes.map(t => t.value).includes(tag)) {
        const tagObj = (Object.values(constants.documentTypes) as DocumentTag[]).find(obj => obj.value === tag);
        if (tagObj) {
          this.documentTypes.push(tagObj);
        }
      }
    }
    console.log('====updated defaultTags: ', this.documentTypes);
    console.log('===policies: ', policies)

    const apiBodyPricingDetails = {
      LoanTerm: loanTerm,
      BrokerageAmount: policies?.brokerage ?? undefined,
      DocFee: policies?.applicationFee ?? undefined,
      TotalAmount: policies?.total ?? undefined,
      PaymentPeriod: 'Monthly',
      DocFeeFinanced: booleanToYesNo(false),
      Rate: this.terms?.totalInterest ?? undefined,
      Repayment: policies?.monthlyInstallment ?? undefined,
    }

    const otherIndividual  = [
      ...otherIndividuals
    ];

    const apiBodyCommercialEntities = [
      primaryCommercialEntity,
      ...otherCommercialEntity,
    ];

    const apiBodyPolicies =  policies?.policies.map( p => {
      return {
        typeOfCover: p.coverType?.ProductName ?? '',
        policyNumber: p.policyNumber ?? '',
        insurer: p.insurer ?? '',
        inceptionDate: p.inceptionDate?.format('DD/MM/YYYY'),
        expiryDate: p.expiryDate?.format('DD/MM/YYYY'),
        premiumAmount: p.premiumAmount ?? 0,
        invoiceNumber: p.invoiceNumber ?? '',
      };
    }) ?? undefined;

    const apiBodyAppInfo = {
      BrokerAppID: this.brokerApplicationId ?? undefined,
      IntroducerGroup: introducerGroup,
      Disclosed: disclosed,
      FinanceType: 'Insurance Premium',
      UserId: user!.UserId,
      OriginatorBusinessId: user!.OriginatorBusinessId,
      UserEmail: user!.Email,
      UserFirstName: user!.GivenName,
      UserLastName: user!.FamilyName,
      Notes: applicationNotes ?? undefined,
      BusinessUse: booleanToYesNo(this.businessUseOnly),
      SelfServiceability:  booleanToYesNo(this.selfServiceability),
      BrokerflowDocumentID: undefined,
      BrokerSalesforceID: brokerSalesforceId,
      BrokerAbn: brokerAbn,
      BrokerEntityName: brokerEntityName,
      AssetCategory: undefined,
      AssetType: undefined,
      ContactId: undefined,
      CustomerId: undefined,
      SalesforceId: undefined,
      StageName: 'Draft',
      LoanPurpose: this.formControlStep2LoanPurpose.value,
    };

    const authorisedSignatories: AuthorisedSignatoryValue = this.formControlStep6AuthorisedSignatories.value;
    const apiBodyAuthorisedSignatory = (authorisedSignatories)?.map(a => {
      return {
        Role: a?.role?.name ?? '',
        Title: a?.title?.type ?? '',
        GivenName: a.firstName ?? '',
        SurName: a.lastName ?? '',
        MiddleName: a.middleName ?? '',
        Email: a.email ?? '',
        MobileNumber: a.mobile ?? '',
      }
    }) ?? undefined;

    const apiBodyContact = fromContactToInteflowContacts(contact);
    // broker contact
    const brokerContact: SalesforceContactSameAccountSelectionValue = this.formControlStep1BrokerContact.value;
    const contacts = contact;
    let apiBodyIndividuals =  otherIndividual.map(individual => ({
      ...individual,
      isPrimaryContact:
        individual.givenName === contacts?.firstName &&
        individual.surname === contacts?.lastName &&
        individual.email === contacts?.email,
    }));

    // The Individual Details step saves its edits straight to ApplicationIndividual, but every
    // draft save and the final submission rebuild this payload from the earlier step forms and
    // full-sync the parties - overlay the saved rows or those writes would revert them.
    if (savedIndividualDetails) {
      apiBodyIndividuals = mergeSavedIndividualsIntoInteflowIndividuals(apiBodyIndividuals, savedIndividualDetails.individuals);
    }

    const apiBody: WizardSubmitData = {
      ApplicationType: 'InsurancePremium',
      IP: this.ip,
      ApplicantLocation: this.geoLocation,
      UserId: this.applicationService.getApplicationUserId(this.existingApplication,this.user),
      OriginatorBusinessId: this.applicationService.getApplicationOriginatorBusinessId(this.existingApplication,this.user),
      AppInfo: apiBodyAppInfo,
      Contacts: apiBodyContact,
      Policies: apiBodyPolicies,
      // AZ-1475: both party arrays go over the wire in the API shape.
      parties: { individuals: apiBodyIndividuals, commercialEntities: apiBodyCommercialEntities },
      PricingDetails: apiBodyPricingDetails,
      AuthorisedSignatory: apiBodyAuthorisedSignatory,
      AcceptQuotation: this.acceptedQuotation,
      ApplicationNotes: applicationNotes ?? undefined,
      CompanyDetails: companyDetails ?? undefined,
      AdditionalBrokerCorrespondent: correspondentDetails ?? null,
      BrokerContact: brokerContact,
      //Documents: apiBodyDocuments,
      DocumentTypes: this.documentTypes,
      AssetSpec: undefined,
      Reference: undefined,
    }
    return apiBody;
  }

  onIdDocumentDelete(document: UploadedDocumentRef) {
    if (!this.step4DeletedIdDocuments.some(candidate => candidate.name === document.name)) {
      this.step4DeletedIdDocuments = [...this.step4DeletedIdDocuments, document];
    }
    this.applicationDocuments = this.applicationDocuments?.filter(candidate => candidate.name !== document.name) ?? null;
    this.step9UploadedDocs = this.step9UploadedDocs.filter(candidate => candidate.name !== document.name);
    this.filesUploadedToAzure = this.filesUploadedToAzure.filter(file => file.name !== document.metadata?.name);
  }

  onStep9DeleteUploadedDoc($event: UploadedFilesListComponentEvent) {
    this.filesUploadedToAzure = this.filesUploadedToAzure
      .filter(file => {
        return !(file.name === $event.deletedFile.metadata?.name);
      });
    this.step9DeletedUploadedDocs = [...$event.deleted];
  }

  get step9OtherDocMetadata() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const abn = this.formControlStep3Abn.value ?? '';
    const legalName = toInteflowLegalName(b) ?? '';

    return {
      abn: abn,
      legalname: legalName
    };
  }

  onStep9DocEvent(files: UploadAzureFiles) {
    if(files && files.length > 0) {
      this.formControlStep9OtherSupportingDocuments.setValue(files)
    } else {
      this.formControlStep9OtherSupportingDocuments.setValue(null)
    }
  }

  applicationDefaultDocuments(includeOptions = false): DocumentTag[] {
    const applicants = this.formControlStep4Applicants.value;
    const individualApplicants = applicantsThatAreIndividual(applicants);
    const names = individualApplicants
      .map(requireDriverLicence => `${requireDriverLicence.firstName} ${requireDriverLicence.lastName}`);
    return this.defaultDocuments(
      'InsurancePremium',
      names,
      // this.formControlStep3OrganisationType.value === EntityTypeTrustOption
      toInteflowLegalName(this.formControlStep1Business.value) ?? "",
      "",
      "",
      (this.formControlStep2Policies.value as PolicyValue)?.total,
      0,
      false,
      this.formControlStep3OrganisationType.value === EntityTypeTrustOption,
      this.formControlStep3OrganisationType.value === EntityTypePartnershipOption,
      includeOptions
    );
  }

  listUploadedDocuments() {
    if (this.applicationId) {
      this.subscriptions.push(
        this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
          (r: AzureStorageDocument[]) => {
            // includes ID documents (driver licence / passport) uploaded through the individual form
            const documents = r.filter(arg => arg.metadata);
            this.step9UploadedDocs = documents;
            this.applicationDocuments = documents;
          }
        )
      )
    }
  }

}
